<template>
  <div class="footer_box" id="footer_box">
    <!-- pc 通用底部 -->
    <div v-if="!isM">
      <footer>
        <div class="footer_top">
          <div class="footer_l">
            <h2>车镇车源</h2>
            <div class="f_con">
              <span>客服：</span>
              <p class="s_txt">4008-227-177</p>
            </div>
            <div class="f_con">
              <span>邮箱：</span>
              <p>kf@chezhency.com</p>
            </div>
            <div class="f_con">
              <span>地址：</span>
              <p>深圳市南山区沙河西路1819号深圳湾科技生态园7栋B座西区10楼</p>
            </div>
          </div>
          <div class="footer_r">
            <div class="fr_l">
              <p>关注我们</p>
              <div class="frl_img">
                <i class="f_img_vx"
                  ><img class="qrcode" :src="picUrl + 'vx_pic.jpg'" alt=""
                /></i>
                <!-- <i class="f_img_vxsp"
                ><img class="qrcode" :src="picUrl+'dt1.jpg'" alt=""
              /></i> -->
              </div>
            </div>
            <div class="fr_r">
              <p>车镇车源APP下载</p>
              <img :src="picUrl + 'vx_code.png'" alt="" />
            </div>
          </div>
        </div>
        <div class="footer_bottom">
          Copyright © 2017 All Rights Reserved 深圳市易车合创科技有限公司
          版权所有 | <a href="https://beian.miit.gov.cn" target="_blank" style="color:#ffffff;">粤ICP备15041172号</a>
        </div>
      </footer>

      <back-to-top
        :custom-style="myBackToTopStyle"
        :visibility-height="300"
        :back-position="50"
        transition-name="fade"
      />
    </div>

    <!-- M 通用底部 -->
    <div v-if="isM">
      <footer>
        <div class="foot_top">
          <div class="ft_1">
            <div class="fr_l">
              <p>关注我们</p>
              <div class="frl_img">
                <i @click="showCode" class="f_img_vx"></i>
                <!-- <i class="f_img_vxsp"></i> -->
              </div>
            </div>
            <div class="fr_r">
              <p>车镇车源APP下载</p>
              <img :src="picUrl + 'icon1.png'" alt="" @click="downLoadApp" />
            </div>
          </div>
          <div class="footer_l">
            <div class="f_con">
              <span>客服：</span>
              <p class="s_txt">4008-227-177</p>
            </div>
            <div class="f_con">
              <span>邮箱：</span>
              <p>kf@chezhency.com</p>
            </div>
            <div class="f_con">
              <span>地址：</span>
              <p>深圳市南山区沙河西路1819号深圳湾科技生态园7栋B座西区10楼</p>
            </div>
          </div>
        </div>

        <div class="footer_bottom">
          Copyright © 2017 All Rights Reserved <br />
          深圳市易车合创科技有限公司 版权所有 | <a href="https://beian.miit.gov.cn" target="_blank" style="color:#ffffff;">粤ICP备15041172号</a>
        </div>
      </footer>
      <button @click="backToTopm" class="back_top">回到顶部</button>

      <div class="show_code" v-show="codeShow" @click="codeShow = false">
        <img :src="picUrl + 'vx_pic.jpg'" alt="" />
      </div>
    </div>
  </div>
</template>
                   
<script>
import BackToTop from "@/components/backtotop";
export default {
  name: "czfooter",
  components: {
    BackToTop,
  },
  props: ["pageName", "backIndex"],
  data() {
    return {
      picUrl: this.$root.picUrl,
      myBackToTopStyle: {
        right: "50px",
        bottom: "50px",
        width: "40px",
        height: "40px",
        "border-radius": "4px",
        "line-height": "45px", // 请保持与高度一致以垂直居中 Please keep consistent with height to center vertically
        background: "#e7eaf1", // 按钮的背景颜色 The background color of the button
      },
      isM: false,
      codeShow: false,
      isAndroid: false,
      isiOS: false,
    };
  },
  created() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    this.isAndroid = isAndroid;
    this.isiOS = isiOS;
    setTimeout(() => {
      this.isM = JSON.parse(sessionStorage.getItem("isM"));
    }, 200);
  },
  methods: {
    backToTopm() {
      window.scrollTo({
        left: 0,
        top: 0,
        behavior: "smooth",
      });
    },
    showCode() {
      this.codeShow = true;
    },
    downLoadApp() {
      if (this.isAndroid) {
        window.open("https://c.chezhency.com", "_blank");
      }
      if (this.isiOS) {
        window.open(
          "https://itunes.apple.com/cn/app/che-zhen-che-yuan/id1022244878?l=en&mt=8",
          "_blank"
        );
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/commonfooter.vue